$(document).ready(function() {

    $("a[data-page]").click(function() {
        $("section").removeClass("active");
        $("section[data-page='" + $(this).data("page") + "']").addClass("active");
    });

    $(".tabbed").each(function() {
        var $tabbed = $(this);
        var $tabs = $tabbed.children().filter(".tabs").children();
        var $contents = $tabbed.children().filter(".content");

        $tabs.click(function() {
            var $tab = $(this);
            var tab = $tab.data("tab");
            $tabs.removeClass("active");
            $tab.addClass("active");
            $contents.removeClass("active");
            $contents.filter("[data-tab='" + tab + "']").addClass("active");
        });
    });

    $("[data-source]").each(function() {
        var $source = $(this);
        var source = $(this).data("source");
        var $fills = $("[data-fill='" + source + "']");
        $fills.each(function() {
            $fill = $(this);
            var $clone = $source.clone();
            var $name = $fill.closest("[data-name]");
            var $date = $fill.closest("[data-date]");
            var $year = $fill.closest("[data-year]");
            var $keyword = $fill.closest("[data-keyword]");
            if ($name.length > 0) {
                var name = $name.data("name");
                $clone.find("[data-id='name']").text(name);
            }
            if ($date.length > 0) {
                var date = $date.data("date");
                $clone.find("[data-id='date']").text(date);
            }
            if ($year.length > 0) {
                var year = $year.data("year");
                $clone.find("[data-id='year']").text(year);
            }
            if ($keyword.length > 0) {
                var keyword = $keyword.data("keyword");
                $clone.find("[data-id='keyword']").text(keyword);
            }
            $fill.html($clone.html());
        });
    });
    
    $("a[data-tooltip]").each(function() {
        var $link = $(this);
        var tooltip = $link.data("tooltip");
        var side = ["top", "left"];
        var max_width = 400;
        if (tooltip === "interpretation-details" || tooltip === "event-interpretation-details" || tooltip === "synthesis-details" || tooltip === "event-curve-details") {
            side = "top";
            max_width = 700;
        }
        $link.tooltipster({
            theme: "tooltipster-borderless",
            content: $("[data-source='" + tooltip + "']").html(),
            contentAsHTML: true,
            trigger: "click",
            delay: 0,
            interactive: true,
            side: side,
            maxWidth: max_width
        });
    });

});